import React from 'react';
interface AvatarProps {
  initials?: string;
  src?: string;
  size?: 'sm' | 'md' | 'lg';
  status?: 'online' | 'offline' | 'away' | 'busy';
  className?: string;
}
export const Avatar: React.FC<AvatarProps> = ({
  initials,
  src,
  size = 'md',
  status,
  className = ''
}) => {
  const sizes = {
    sm: 'w-8 h-8 text-xs',
    md: 'w-10 h-10 text-sm',
    lg: 'w-12 h-12 text-base'
  };
  const statusColors = {
    online: 'bg-status-success',
    offline: 'bg-gray-400',
    away: 'bg-status-warning',
    busy: 'bg-status-error'
  };
  return <div className={`relative inline-flex items-center justify-center rounded-full bg-fpg-navy-light text-white font-medium ${sizes[size]} ${className}`} data-id="element-150">
      {src ? <img src={src} alt="Avatar" className="w-full h-full rounded-full object-cover" data-id="element-151" /> : <span data-id="element-152">{initials}</span>}
      {status && <span className={`absolute bottom-0 right-0 block rounded-full ring-2 ring-white ${statusColors[status]}`} style={{
      width: '25%',
      height: '25%'
    }} data-id="element-153" />}
    </div>;
};